import React, { useRef, useEffect } from "react";
import cx from "classnames";
import { Close } from "@material-ui/icons";

const InspectorClose = ({ onClick }) => (
  <button className="field_inspector__close" onClick={onClick}>
    <Close style={{ fontSize: 14 }} />
  </button>
);

const InspectorField = ({ title, value }) => (
  <div className="field_inspector__stack">
    <div className="field_inspector__label">{title}</div>
    <div
      className={cx("field_inspector__value", {
        "field_inspector__value--trunc": !["Errors", "Alert", "Description"].includes(title),
        "field_inspector__value--lg": ["Errors", "Alert", "Description"].includes(title),
      })}
    >
      {value || "--"}
    </div>
  </div>
);

const FieldInspector = ({ cellData, onClose, inspectorContainer }) => {
  const elRef = useRef(null);

  const setPosition = () => {
    const rect = inspectorContainer.getBoundingClientRect();
    const center = rect.left + (rect.right - rect.left) / 2;
    elRef.current.style.left = `${center}px`;
    elRef.current.style.maxWidth = `${rect.width - 48}px`;
  };

  useEffect(() => {
    if (!elRef.current || !inspectorContainer) return;

    setPosition();
  });

  if (cellData.column) {
    return (
      <div className="field_inspector" ref={elRef}>
        <InspectorField title="Description" value={cellData.column.description} />
        <div className="field_inspector__divider" />
        <InspectorField
          title="Errors"
          value={
            cellData.column.warnings?.length
              ? cellData.column.warnings
                  .map((w) =>
                    w.mappedValue
                      ? `${w.filename}: Unexpected column name '${w.mappedValue}'`
                      : `${w.filename}: Invalid or incorrect column mapping.`
                  )
                  .join(", ")
              : null
          }
        />
        <InspectorClose onClick={onClose} />
      </div>
    );
  }

  return (
    <div className="field_inspector" ref={elRef}>
      <InspectorField title="Original Value" value={cellData.originalValue} />
      <div className="field_inspector__divider" />
      <InspectorField title="Processed Value" value={cellData.value} />
      <div className="field_inspector__divider" />
      <InspectorField
        title="File"
        value={cellData.filename ? `${cellData.filename} (line ${cellData.lineNumber})` : null}
      />
      <div className="field_inspector__divider" />
      <InspectorField title="Alert" value={cellData.message} />
      <InspectorClose onClick={onClose} />
    </div>
  );
};

export default FieldInspector;
